import { ModulePack_Static_HCS } from './healthcare-space.js';
import { ModulePack_Static_Pathway } from './pathway.js';
import { ModulePack_Static_DiseaseProfile } from './disease-profile.js';
import { ModulePack_Static_AdvisorContext } from './advisor-context.js';
import { ModuleFE_Advisor_NoteTemplate } from './note-template.js';
import { ModulePack_Static_Organization } from './organization.js';
import { ModuleFE_Advisor_AppConfig } from './app-config.js';
import { ModulePack_Static_FHIR } from './fhir.js';
import { ModulePack_Static_AdvisorUI } from './advisor-ui/index.js';
/*IMPORTANT: Do not add modules from other libs here!
* Any module added here must extend ModuleFE_AdvisorStatic
*/
export const ModulePack_AdvisorStatic = [
    ...ModulePack_Static_HCS,
    ...ModulePack_Static_Pathway,
    ...ModulePack_Static_DiseaseProfile,
    ...ModulePack_Static_AdvisorContext,
    ModuleFE_Advisor_NoteTemplate,
    ...ModulePack_Static_AdvisorUI,
    ...ModulePack_Static_Organization,
    ...ModulePack_Static_FHIR,
    ModuleFE_Advisor_AppConfig
];
//# sourceMappingURL=module-pack.js.map